import React, { Component } from 'react';
import moment from 'moment';
import SearchBookingsError from '../../components/dashboard/SearchBookingsError';
import  { db, COLLECTION_BOOKINGS } from '../../firebase';
import logger from '../../services/logger';


export const RESULT_LIMIT = 25;

export function withManageBookingsProvider(WrappedComponent) {
    return class extends Component {
        state = {
            bookings: null,
            isLoading: false,
            rangeStart: moment(),
            rangeEnd: moment().add(1, 'week'),
            resultsCount: 3,
            hasError: false,
            rangeError: false,
            uuidLookup: {},
        };

        componentDidMount() {
            this.fetchBookings();
        }

        fetchBookings = async () => {
            const { rangeStart, rangeEnd } = this.state;

            this.setState({ isLoading: true });

            try {
                const uuidLookup = {};
                const bookings = [];
                const snapshot = await db.collection(COLLECTION_BOOKINGS)
                    .where('date_time', '>', rangeStart.toDate())
                    .where('date_time', '<', rangeEnd.toDate())
                    .limit(RESULT_LIMIT)
                    .get();

                    if (!snapshot.empty) {
                        snapshot.forEach(doc => {
                            const record = doc.data();

                            uuidLookup[record.uuid] = doc.id;

                            bookings.push(record);
                        });
                    }

                    this.setState({ uuidLookup, bookings, isLoading: false });
            } catch(e) {
                logger.error('Error fetching a list of bookings in the dashboard: ' + JSON.stringify(e));

                this.setState({ hasError: true });
            }
        }

        handleDateRangeChange = dates => {
            let rangeStart = dates[0];
            let rangeEnd = dates[1];

            if (rangeStart > rangeEnd) {
                rangeStart = dates[1];
                rangeEnd = dates[0];
            }

            const diff = rangeEnd.diff(rangeStart, 'days');

            if (diff > 30) {
                return this.setState({ rangeError: true });
            }

            this.setState({
                rangeStart,
                rangeEnd,
                rangeError: false,
            }, this.fetchBookings);
        }

        render() {
            const {
                bookings,
                uuidLookup,
                isLoading,
                rangeStart,
                rangeEnd,
                rangeError,
                hasError,
            } = this.state;

            if (hasError) {
                return <SearchBookingsError />;
            }

            return (
                <WrappedComponent
                    isLoading={isLoading}
                    bookings={bookings}
                    uuidLookup={uuidLookup}
                    fetchBookings={this.fetchBookings}
                    handleDateRangeChange={this.handleDateRangeChange}
                    dateRange={[rangeStart, rangeEnd]}
                    rangeError={rangeError}
                />
            );
        }
    };
}
